import React from 'react'
import pt from 'prop-types'
import { TextBox } from '../TextBox'
import { CheckBox } from '../CheckBox'
import { ComboBox } from '../ComboBox'
import { MultiSelectBox } from '../MultiSelectBox'
import { sh } from 'common-data/datahelpers'
import { NumberBox } from '../NumberBox'
import { ViewBox } from '../ViewBox'
import { StaticBox } from '../StaticBox'
import { DateBox } from '../DateBox'
import { ReactReduxContext } from 'react-redux'

export class DynamicFieldBox extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      renderTypeId: 0,
      renderOptions: null,
      extraProps: null
    }
  }

  static contextType = ReactReduxContext

  static propTypes = {
    getRenderData: pt.func.isRequired,
    switchFieldName: pt.string.isRequired,
    formName: pt.string.isRequired
  }

  componentDidMount () {
    const { getRenderData, formName, switchFieldName } = this.props
    console.log(this.context)
    const { store } = this.context

    let switchFieldValue = sh.FormValues(formName, [switchFieldName])(store.getState())
    let renderData = getRenderData(switchFieldValue, switchFieldName)

    this.setState({
      renderTypeId: renderData.typeId || 0,
      renderOptions: renderData.options,
      extraProps: renderData.extraProps || {},
      readOnly: renderData.readOnly === true
    })
  }

  render () {
    const { renderType, formName, switchFieldName, ...rest } = this.props
    const { renderTypeId, renderOptions, extraProps, readOnly } = this.state

    if (readOnly === true) {
      if (renderTypeId === 3) {
        return <StaticBox {...rest} options={renderOptions} {...extraProps} />
      } else {
        return <ViewBox {...rest} {...extraProps}/>
      }
    }

    switch (renderTypeId) {
      case 0:
        return <ViewBox {...rest} {...extraProps} />
      case 1: // text
        return <TextBox {...rest} {...extraProps} />
      case 2: // checkbox
        return <CheckBox {...rest} {...extraProps} />
      case 3: // single select
        return <ComboBox {...rest} options={renderOptions} {...extraProps}/>
      case 4: // multi select
        return <MultiSelectBox {...rest} options={renderOptions} {...extraProps}/>
      case 5:
        return <NumberBox {...rest} {...extraProps}/>
      case 6:
        return <NumberBox {...rest} {...extraProps}/>
      case 7:
        return <DateBox {...rest} {...extraProps}/>
      default: // text
        return <TextBox {...rest} />
    }
  }
}

export default DynamicFieldBox
